import './base/';

import './utils/check-device-resolution';

import './modules/init-sliders';
import './modules/add-click-events';
import './modules/sticky-header';
import './modules/list-count';
import './modules/product-quantity';
import './modules/ajax-cart';
import './modules/currency-handler';
import './modules/accordions';
import './modules/recommendation-products';
import './modules/sticky-add-to-cart';
import './modules/product-fixed-image';
import './modules/product-options-handler';
import './modules/cart-fixed-sidebar';
import './modules/snize-custom';
import './modules/tabs';
import './modules/help-page';
import './modules/init-custom-scrollbar';
import './modules/aos';
import { initAristot } from './aristot/aristot';

const $window = $(window);
const $document = $(document);
const $body = $('body');

// Your code goes here...
// jQuery.ready is no longer needed

initAristot();

$window.on('load', function () {
  $body.addClass('page-load');
});
